import { action } from 'satcheljs';
import PersonalBookingPageSettings from 'owa-service/lib/contract/GetPersonalSchedulingPageResponseMessage';

/**
 * Action to initialize the personal booking page settings in store.
 */
let initializeSettings = action(
    'INITIALIZE_PBP_SETTINGS',
    (pbpSettings: PersonalBookingPageSettings) => ({
        pbpSettings,
    })
);

export default initializeSettings;
